export { App as default } from '@guiker/payout-main-mfe'
